module.exports = __webpack_public_path__ + "img/0Q3A6952_P_L_Wood.524a273f.jpg";